function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.993 6.75a.5.5 0 00.406-.792l.001.001-3.6-5.04A1.001 1.001 0 0017.986.5H12.75a.5.5 0 00-.5.5v5.25a.5.5 0 00.5.5zM1 8.25a.5.5 0 00-.5.5V22.5a1 1 0 001 1h21a1 1 0 001-1V8.75a.5.5 0 00-.5-.5zM12.5 18a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5zM10.75 1a.5.5 0 00-.5-.5H6.014a1 1 0 00-.812.416L5.2.919l-3.6 5.04a.5.5 0 00.407.791h8.243a.5.5 0 00.5-.5z"
});

function SvgSpCiBuild(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "spCIBuild.e211f.svg";
export { SvgSpCiBuild as ReactComponent };